import { render } from "./PhindBotSettings.vue?vue&type=template&id=f7d51668"
import script from "./PhindBotSettings.vue?vue&type=script&lang=js"
export * from "./PhindBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__